import styles from '../settings.module.css';
import { DigitalAlertsAudioSettings } from './DigitalAlertAudioSettings';
import DigitalAlertsBannerSettings from './DigitalAlertsBannerSettings/DigitalAlertsBannerSettings';

export const DigitalAlertsSettings = () => {
  return (
    <div className={styles.section}>
      <h2 className={styles.title}>Digital Alerts</h2>
      <div className={styles.description}>
        Manage notifications for automated digital alerts from connected
        devices, vehicle telematics, etc.
      </div>
      <div className={styles.cardBlock}>
        <DigitalAlertsBannerSettings />
        <DigitalAlertsAudioSettings />
      </div>
    </div>
  );
};
